import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next'
import { CMSPath } from '../../../config/constant';
import GuideCompContainer from './guideCompContainer';
import img_liveliness from "./assets/img_liveliness.svg";
class LivelinessTip extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { t } = this.props
        return (

            <div className='help-info liveliness-info'>
                <header class="inner-pages w-footer subpages">
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                    </div>
                </header>

                <section class="widgets padding-0 margin-0 container-bg" style={{ minHeight: "100vh" }} >

                    <div class="widget-header widget-header-checkin-howto">
                        <div class="widget-header-title">{t('check_in.liveliness_check')}</div>
                    </div>

                    <div class="multi-tips gallery-alt">
                        <div class="multi-tips-main">
                            <div class="multi-tips-container">
                                <GuideCompContainer
                                    image={img_liveliness}
                                    text={t('check_in.liveliness_texts')}
                                />
                            </div>

                            <div class="multi-tips-controls">
                                <button class="button primary" onClick={this.props.backBtn}>{t('check_in.ok_got_it')}</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        menuColor: state.store.home.MenuColor
    }
}

export default connect(mapStateToProps)(withTranslation('translations')(LivelinessTip));